import type { PropsWithChildren } from 'react'
import React from 'react'
import setStyleVariables from '../utilities/setStyleVariables'
import { LocaleProvider } from './LocaleContext'

export interface UiProviderProps {
  primary?: string
  secondary?: string
}

function UiProvider({
  children,
  primary,
  secondary,
}: PropsWithChildren<UiProviderProps>): JSX.Element {
  setStyleVariables({ primary, secondary })

  return <LocaleProvider>{children}</LocaleProvider>
}

export { UiProvider }
